export const colors = {
  accent: '#3453F5',
  primary: '#ffff00',
  secondary: '#0000ff',
  darkGrey: '#3a3a3a',
  grey: '#757575',
  lightGrey: '#e5e5e5',
  lightestGrey: '#f2f2f2',
  black: '#000000',
  white: '#ffffff',
};
